import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Gift, Calendar } from "lucide-react";
import { format, parseISO } from "date-fns";
import { sv } from "date-fns/locale";
import { formatPrice } from "@/utils/formatPrice";

// Matches get-public-landing edge function response for gift_card
interface GiftCardEntity {
  amount: number;
  remaining_amount: number;
  currency: string;
  expires_at: string | null;
  status: string;
  description: string | null;
}

interface Props {
  entity: Record<string, unknown>;
  onAction: (path: string) => void;
  brandColor?: string;
}

export default function GiftCardLanding({ entity, onAction, brandColor }: Props) {
  const card = entity as unknown as GiftCardEntity;
  const isExpired = card.expires_at ? new Date(card.expires_at) < new Date() : false;
  const isUsed = card.remaining_amount <= 0;

  return (
    <div className="space-y-4">
      <div className="text-center space-y-2">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <Gift className="h-8 w-8 text-primary" />
        </div>
        <h1 className="text-2xl font-bold">Presentkort</h1>
      </div>

      <Card className="border-2">
        <CardContent className="p-6 space-y-4">
          <div className="text-center">
            <p className="text-4xl font-bold" style={brandColor ? { color: brandColor } : undefined}>
              {formatPrice(card.amount)}
            </p>
            {card.remaining_amount < card.amount && card.remaining_amount > 0 && (
              <p className="text-sm text-muted-foreground mt-1">
                Kvarvarande: {formatPrice(card.remaining_amount)}
              </p>
            )}
          </div>

          {card.description && (
            <p className="text-sm text-center text-muted-foreground">
              {card.description}
            </p>
          )}

          {card.expires_at && (
            <div className="flex items-center gap-2 text-sm justify-center">
              <Calendar className="h-4 w-4 text-muted-foreground" />
              <span>
                Giltigt till: {format(parseISO(card.expires_at), "d MMMM yyyy", { locale: sv })}
              </span>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Action */}
      <Button
        className="w-full text-base py-6"
        style={brandColor ? { backgroundColor: brandColor } : undefined}
        disabled={isExpired || isUsed || card.status !== "active"}
        onClick={() => onAction("/profile")}
      >
        {isExpired
          ? "Presentkortet har gått ut"
          : isUsed
          ? "Presentkortet är förbrukat"
          : "Lös in presentkort →"}
      </Button>
    </div>
  );
}
